import { Order } from "../services";
import { MoveToProgressType } from "../services/OrderSettings";
import { OrderStatus } from "../types";

/**
 * The orders tab of an order the server left without `stage` (it is null
 * while the auto move to «executing» waits for its delay).
 */
const resolveAllStage = (
	order: Order.Model,
	timeToLive: number,
): Order.OrderStage | undefined => {
	const futureTime = timeToLive ? Date.now() + timeToLive : 0;
	const {
		orderDate,
		moveToProgress,
		isPreliminary,
		status,
		executorToOrder,
		executingStages,
	} = order;

	const parsedOrderDate = orderDate ? new Date(orderDate).getTime() : 0;
	const isLastTime = parsedOrderDate <= futureTime;
	const isMoreTime = parsedOrderDate > futureTime;
	const isMoveVal = !!moveToProgress?.value;
	const isEmptyExecutorToOrder = !executorToOrder?.length;
	const isTaken =
		status === OrderStatus.EXECUTING || Boolean(executingStages?.accepted);

	if (
		status !== OrderStatus.CLOSED &&
		!isTaken &&
		((!isMoveVal && isLastTime) ||
			(status === OrderStatus.FREE_WAVE && isEmptyExecutorToOrder))
	) {
		return Order.ORDERS_STAGE.LIVE;
	}
	if (isPreliminary && isMoreTime) {
		return Order.ORDERS_STAGE.PRELIMINARY;
	}
	// The auto move waits for its delay: the taken order stays live until
	// the server sets `executable` (dev check G2).
	if (
		isTaken &&
		moveToProgress?.type === MoveToProgressType.AUTO &&
		moveToProgress.value === false
	) {
		return Order.ORDERS_STAGE.LIVE;
	}
	if (isTaken && (!isPreliminary || isLastTime)) {
		return Order.ORDERS_STAGE.EXECUTABLE;
	}
	return undefined;
};

export default resolveAllStage;
